import { PUSH_NOTIFICATION, REMOVE_MESSAGE, PUSH_ALL_MESSAGES, SET_APP_TYPE } from "./types";
import { buildBot, checkBotStatus } from "./intentsActions";

export const removeMessage = () => {
  return function(dispatch) {
    dispatch({ type: REMOVE_MESSAGE });
  };
};

export const pushMessage = props => async (dispatch, getState) => {
  dispatch({
    type: PUSH_NOTIFICATION,
    payload: {
      preventDuplicate: props.preventDuplicate,
      message: props.message,
      type: props.type,
      persist: props["persist"],
      removePrevious: props["removePrevious"]
    }
  });
};

export const setAppType = appType => ( dispatch ) => {
  dispatch({ 
    type: SET_APP_TYPE,
    payload: appType
  })
}

export const pushAllMessagesInStore = props => async (dispatch, getState) => {
  dispatch({
    type: PUSH_ALL_MESSAGES,
    payload: props
  });
};

// export const handleBotStatus = () => async (dispatch, getState) => {
//   console.log("handleBotStatus", "inside");
//   let response = await checkBotStatus();
//   console.log(response);
//   console.log("handleBotStatus", "after");
//   if (response["refresh"] === false) {
//     pushMessage({ message: this.props.botStatus.message, type: this.props.botStatus.type });
//   } else {
//     setTimeout(() => {
//       handleBotStatus();
//     }, response["refreshInterval"]);
//   }
// };
//
// export const buildBotAndShowProgress = () => async (dispatch, getState) => {
//   console.log("buildBotAndShowProgress", "inside");
//   pushMessage({ message: "Bot is building", type: "info" });
//   console.log("buildBotAndShowProgress", "after");
//   let response = await buildBot();
//   if (response["successful"] === true) {
//     handleBotStatus();
//   } else {
//     this.props.pushMessage({
//       message:
//         "Bot building failed. Please try again in few minutes or contact you administrator. Error: " + response.message,
//       type: "error"
//     });
//   }
// };
